<template>
  <div class="desktop-home">
    <Banner />
    <Feature />
    <Testimonial />
    <Partner />
  </div>
</template>

<script>
import Banner from './Banner.vue';
import Feature from './Feature.vue';
import Testimonial from './Testimonial.vue';
import Partner from './Partner.vue';

export default {
  name: 'Home',
  components: {
    Banner,
    Feature,
    Testimonial,
    Partner,
  },
};
</script>
<style>
.desktop-home section {
  margin-bottom: 100px;
}
.desktop-home section .section-caption {
  font-family: "GothamBold";
  font-size: 40px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 48px;
  letter-spacing: normal;
  margin-bottom: 40px;
  color: #5e51a1;
}
</style>
